<template>
  <component
    :is="tag"
    :id="id"
    :role="role"
    :aria-live="ariaLive"
    :aria-atomic="ariaLive ? 'true' : null"
    :class="{
      'd-block': show,
      'invalid-feedback': !tooltip,
      'invalid-tooltip': tooltip
    }"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'BFormInvalidFeedback',
  props: {
    state: Boolean,
    forceShow: Boolean,
    tooltip: Boolean,
    id: {
      type: String,
      default: undefined
    },
    tag: {
      type: String,
      default: 'div'
    },
    ariaLive: {
      type: String,
      default: undefined
    },
    role: {
      type: String,
      default: undefined
    }
  },
  computed: {
    show() {
      return this.forceShow || this.state
    }
  }
}
</script>
